import React, { useEffect, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Link } from '@material-ui/core'
import { CircularProgress } from '@material-ui/core'

import { LinkOffRounded as LinkIcon } from '@material-ui/icons'

import api from '../../../services/api'

import {
  getUsefulLinks,
  setUsefulLinks,
  usefulLinksError,
} from '../../../redux/usefulLinks/actions'

import { isArray } from '../../../utils/customMethods'
import Typography from '../../atoms/display/typography'
import EmptyState from '../../atoms/display/emptyState'

import useStyles from './UsefulLinksStyle'

const UsefulLinks = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const classes = useStyles()

  const history = useSelector((state) => state.history)
  const usefulLinks = useSelector((state) => state.usefulLinks)
  const activeConversation = useSelector((state) => state.activeConversation)
  const conversations = useSelector(
    (state) => state.conversations.conversations
  )
  const consumer = useSelector(
    () => conversations[activeConversation]?.consumer
  )

  const chatId = props?.chatId
    ? props.chatId
    : !props?.isHistoryNotes
    ? activeConversation
    : null
  const chat =
    conversations[chatId] ?? history?.conversations[consumer?.id]?.[chatId]
  const skillId = chat?.skillId

  const links =
    isArray(usefulLinks?.skills?.[skillId]) &&
    usefulLinks?.skills?.[skillId]?.length > 0 &&
    usefulLinks?.skills[skillId].filter((e) => e.category === 'link')

  const getLinks = async (id, global) => {
    dispatch(getUsefulLinks())
    try {
      const response = await api.get(
        `/dashboard?${
          (id ? `&skills_id=${id}` : '') + (global ? `&global=${global}` : '')
        }`
      )
      if (response.status === 200) {
        let data = { [id]: response?.data?.data?.index }
        dispatch(setUsefulLinks(data))
      } else {
        throw response.data
      }
    } catch (error) {
      let message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message
      dispatch(
        usefulLinksError({ action: 'get_useful_links', message: message })
      )
    }
  }

  const renderData = () => {
    return (
      <>
        {usefulLinks?.status?.get_useful_links?.loading ? (
          <div className={classes.loadingSection}>
            <CircularProgress size={25} color="primary" />
          </div>
        ) : links ? (
          <>
            {links.map((e) => (
              <Typography variant="body1">
                <Link
                  className={classes.usefulLink}
                  href={e?.info?.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {e?.info?.title}
                </Link>
              </Typography>
            ))}
          </>
        ) : (
          <EmptyState text={t('alerts.noLinksFound')}>
            <LinkIcon />
          </EmptyState>
        )}
      </>
    )
  }

  useEffect(() => {
    !usefulLinks?.skills?.[skillId] && getLinks(skillId, true)
  }, [skillId])

  return (
    <>
      <div className={classes.content} style={{ padding: 5 }}>
        <table width="100%" cellPadding="10">
          <tbody>
            <tr>
              <td colSpan="2">{renderData()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}

export default memo(UsefulLinks)
